import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { Page } from "../Page";
import { ColumnLayout } from "@/components/Layout/ColumnLayout";
import { DisputesList } from "@/components/Reports/Disputes/DisputesList";

export const DisputesPage = () => {
    return (
        <Page title="Disputes">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item>Disputes</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    <div className="px-6 pt-3 pb-20">
                        <DisputesList />
                    </div>
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
